import type { InertiaConfig } from "@inertiajs/core"
import { usePage } from "@inertiajs/vue3"
import { computed } from "vue"

/**
 * Derives auth user details from Inertia shared props.
 * Centralizes the user/name/avatar computeds used across
 * UserMenu, DefaultLayout, and the More page.
 */
export function useAuthUser() {
  const page = usePage<InertiaConfig["sharedPageProps"]>()

  const authUser = computed(() => page.props.auth?.user)

  const userName = computed(() => {
    if (!authUser.value) return "User"
    return [authUser.value.first_name, authUser.value.last_name].filter(Boolean).join(" ")
  })

  const avatarSrc = computed(
    () => authUser.value?.avatar_url ?? authUser.value?.gravatar_url ?? undefined,
  )

  const isAccountOwner = computed(() => page.props.auth?.is_account_owner ?? false)
  const isSuperAdmin = computed(() => page.props.auth?.is_super_admin ?? false)

  return { authUser, userName, avatarSrc, isAccountOwner, isSuperAdmin }
}
